import React, { useState } from "react";
import one from "../../assets/Order/one.svg";
import two from "../../assets/Order/two.svg";
import three from "../../assets/Order/three.svg";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const VendorTiles = ({ data }) => {
  const { t, i18n } = useTranslation();

  const values = {
    // 1: {
    //   img: one,
    //   heading: t("Purchase Value"),
    //   productsleft: `${t("EGP")} ${
    //     data?.purchase_value?.toFixed(2) || "EGP 0.00"
    //   } `,
    //   bgcolor: "#D1F1FC",
    //   textcolor: "#374151",
    // },
    // 2: {
    //   img: two,
    //   heading: t("Sales Value"),
    //   productsleft: `${t("EGP")} ${
    //     data?.sales_value?.toFixed(2) || "EGP 0.00"
    //   }`,
    //   bgcolor: "#D1F1FC",
    //   textcolor: "#374151",
    // },
    3: {
      img: three,
      heading: t("Inventory (Today)"),
      productsleft: `${data?.inventory || "0"} `,
      bgcolor: "#D1F1FC",
      textcolor: "#374151",
    },
    4: {
      img: three,
      heading: t("Inventory Days"),
      productsleft: `${Math.round(data?.inventory_days) || "0"} `,
      bgcolor: "#D1F1FC",
      textcolor: "#374151",
    },
    5: {
      img: three,
      heading: (
        <>
          {t("Daily Avg. Sale")} ({t("Last 30 Days")})
          {/* {t("Daily Avg. Sale")} <br /> ({t("Last 30 Days")}) */}

        </>
      ),
      // heading: t("Daily Avg. Sale (Last 30 Days)"),
      productsleft: `${data?.daily_avg_sale?.toFixed(2) || "0.00"} `,
      bgcolor: "#D1F1FC",
      textcolor: "#374151",
    },
  };

  const tileValues = values;

  return (
    <div className="flex flex-wrap mt-2 border-b mb-5">
      {Object.values(tileValues).map((val, index) => (
        <div key={index} className="w-1/3 sm:w-1/3 md:w-1/3 xl:w-1/3 px-2 mb-2">
          <div
            style={{ backgroundColor: val.bgcolor }}
            className="w-full h-26 rounded-lg flex items-center mb-2 p-2 shadow-sm relative"
          >
            <div className="me-2">
              <img src={val.img} alt={val.heading} width={35} height={35} />
            </div>
            <div>
              <p className="font-normal text-base text-clip">{val.heading}</p>
              <p
                style={{ color: val.textcolor }}
                className="font-medium text-xl truncate"
              >
                {val.productsleft}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default VendorTiles;
